export class serviceAppointmentTimeSlotModel {
    practiceCode: any;
    providerCode: any;
    locationCode: any;
    reasonID: any;
    date: any;
    patientAccount: any;
    patientTimeZone: any;
    isTelehealth: any;
    isFirstAvailable: any;
}
export class appointmentTimeSlotModel {
    availableDate: string;
    availableSlot: string;
    isInsurance: boolean;
    appointmentCharges: string;
    appointmentChargesWithSign: string;
}
export class ProviderModel {
    providerCode: string;
    providerName: string;
    providerPrefix: string;
}
export class appointmentReasonModel {
    reasonId: string;
    reasonName: string;
}
export class addAppointmentRequest
{
    practice_code: any;
    patient_Account: any;
    provider_Code: any;
    location_Code: any;
    app_date: any;
    first_Name: any;
    last_Name: any;
    dateofBrith: any;
    phone: any;
    app_ReasonId: any;
    time_From: any;
    client_IP: any;
    email: any;
    teleMedicine_Session: any;
    patTimeZone: any;
    isConsentForm: any;
} 
